export default "__VITE_PUBLIC_ASSET__392b626d__"